import { useContext } from "react";
import { WidgetContext } from "../../components/widgetContext";

export const useWidgetContext = () => {
  const context = useContext(WidgetContext);
  return context;
};
